import React, { useEffect } from 'react';
import builderPathInit from '../../util/builder-path-init';
import { fetchState, useUser } from '../../context/UserContext';

import okendoReviewsBuilderConfig from
  '../../components/okendo-reviews/okendo-reviews.builder.config';
import OkendoReviews from '../../components/okendo-reviews/okendo-reviews';

const { BuilderPage, getServerSideProps } = builderPathInit({
  model: 'builder-page',
  pathPrefix: 'b',
  components: [
    {
      config: okendoReviewsBuilderConfig,
      component: OkendoReviews,
    },
  ],
});

function MarketingPage(props) {
  const { user, userFetchState } = useUser();

  useEffect(() => {
    if(userFetchState === fetchState.COMPLETE && Object.keys(user).length < 1) {
      if (window.analytics) {
        window.analytics.reset();
      }
    }
  }, [user, userFetchState]);
  return <BuilderPage {...props} />;
};

export default MarketingPage;
export { getServerSideProps };
